// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8da028ec","977":"9fee6687"}[chunkId] + ".chunk.js";
};